<template>
    <div id="userList">
        <div class="title" v-if="!allowChange">
            <p>已超过计划结束时间，无法再次编辑</p>
        </div>
        <div class="searchContent">
            <div class="p_select">
                <a class="back_btn" @click="back"><i class="el-icon-back"></i>返回</a>
            </div>
        </div>
        <div class="list_content">
            <div style="padding: 24px 0;">
                <p class="title_detail">计划名称：{{this.rowData.workerPlanName}} </p>
                <p class="title_detail">计划时间：{{this.rowData.startTime.slice(0, 10)}} --- {{this.rowData.endTime.slice(0, 10)}}</p>
            </div>

            <el-table :data="positionList" highlight-current-row ref="table" :row-key="row => row.id" :height="winHeight">
                <el-table-column prop="positionId" align="left" label="部位ID" fixed="left"></el-table-column>
                <el-table-column prop="positionName" align="left" label="部位名称" fixed="left">
                    <template slot-scope="scope">
                        <span :style="scope.row.status === 'change' ? 'color: red;' : ''">{{scope.row.positionName}}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="configName" align="left" label="总预检目标(台次)" fixed="left">
                    <template slot-scope="scope">
                        <el-input v-model="scope.row.checkTotal" size="small" type="number" :disabled="!allowChange" @change="changInput($event,scope.row)"></el-input>
                    </template>
                </el-table-column>
                <el-table-column prop="configName" align="left" label="总渗透率目标(数量)" fixed="left">
                    <template slot-scope="scope">
                        <el-input v-model="scope.row.total" size="small" type="number" :disabled="!allowChange" @change="changInput($event,scope.row)"></el-input>
                    </template>
                </el-table-column>

                <div v-if="positionList.length > 0">
                    <el-table-column
                            v-for="(item, index) in positionList[0].workerExpectationList"
                            :key="item.workerId"
                            :label="item.name"
                    >
                        <template slot-scope="scope">
                            <el-input v-model="scope.row.workerExpectationList[index].checkTarget" size="small" type="number"
                                      onmousewheel="this.value=this.value.replace(/\D/g,'')" onkeyup="this.value=this.value.replace(/\D|^/g,'')"
                                      onafterpaste="this.value=this.value.replace(/\D|^0/g,'')"
                                      @input="onOrderIndexChanged($event)"
                                      @change="changInput($event,scope.row)"
                                      placeholder="预检目标值"
                                      :disabled="!allowChange"
                            ></el-input>

                            <br/>

                            <div style="margin-top: 6px">
                                <el-input v-model="scope.row.workerExpectationList[index].expectation" size="small" type="number"
                                          onmousewheel="this.value=this.value.replace(/\D/g,'')" onkeyup="this.value=this.value.replace(/\D|^/g,'')"
                                          onafterpaste="this.value=this.value.replace(/\D|^0/g,'')"
                                          @input="onOrderIndexChanged($event)"
                                          @change="changInput($event,scope.row)"
                                          placeholder="渗透率目标值"
                                          :disabled="!allowChange"
                                ></el-input>
                            </div>

                        </template>

                    </el-table-column>
                </div>

                <el-table-column label="操作" fixed="right">
                    <template slot-scope="scope">
                        <el-button
                                @click="saveOption(scope.row)"
                                :class="scope.row.status === 'change' ? 'change_btn' : 'update_btn'"
                                size="small"
                                :disabled="!allowChange"
                        >保存</el-button>
                    </template>
                </el-table-column>

            </el-table>

        </div>
    </div>
</template>

<script>
  import net from "../../assets/js/public";
  import moment from 'moment'
  export default {
    name: "projectConfigDetail",
    data() {
      return {
        positionList:[],
        rowData:'',
        allowChange: false,

        orginUserArr:[],

        winHeight:'200'
      };
    },
    created() {
      var signInfo = JSON.parse(sessionStorage.getItem("signInfo"));
      this.orderPageShowOrgName = signInfo.orgId == 0;
      let rowData = JSON.parse(sessionStorage.getItem("planDetailWorker"))
      this.rowData = rowData


      this.getListData()

      const windiwHight = document.documentElement.clientHeight || document.body.clientHeight; // 可视屏幕高度
      this.winHeight = windiwHight  - 300;

      let endTime = moment(rowData.endTime).unix()
      let nowTime = moment(new Date()).unix()
      if(endTime > nowTime){
        this.allowChange = true
      }else this.allowChange = false

    },
    methods: {
      async getListData() {
        await net.request("manage/workerPlan/getWorkerList", "post", { orgId: this.rowData.orgId }).then(res => {
          if (res.code === 0) {
            this.orginUserArr = res.data;
          } else {
            net.message(this, "获取数据失败", "warning");
          }
        });
        const params = {
          targetPlanId: this.rowData.workerPlanId
        }
        await net.request("manage/workerPlan/targetList","post", params).then(res => {
          if (res.code === 0) {
            let data = res.data
            if(data){
              data.forEach(item => {
                item.total = item.total? item.total : ''
                item.checkTotal = item.checkTotal? item.checkTotal : ''
                item.status = 'save'

                if(!item.workerExpectationList){ // 未录入
                  let orginUserArrNoExist = this.orginUserArr
                  let noList = []
                  orginUserArrNoExist.forEach(user => {
                    noList.push({
                      workerId: user.id,
                      name: user.name,
                      positionId: item.positionId,
                      workerPlanId: item.workerPlanId,
                      expectation:'',
                      checkTarget:'',
                    })
                  })
                  item.workerExpectationList = noList.sort(this.compareAsc("workerId"))
                  // item.workerExpectationList = noList

                }else { // 已录入
                  let workerExpectationList = item.workerExpectationList
                  let orginUserArrExist = this.orginUserArr

                  let filterArr = []
                  for(let i = 0 ; i < workerExpectationList.length; i++){
                    for(let j = 0; j < orginUserArrExist.length; j++){
                      if(workerExpectationList[i].workerId*1 === orginUserArrExist[j].id*1){
                        filterArr.push({
                          expectation: workerExpectationList[i].expectation,
                          checkTarget: workerExpectationList[i].checkTarget,
                          workerId: orginUserArrExist[j].id,
                          name: orginUserArrExist[j].name,
                          positionId: workerExpectationList[i].positionId,
                          workerPlanId: workerExpectationList[i].workerPlanId,
                        })
                      }else {
                        filterArr.push({
                          expectation: "",
                          checkTarget: "",
                          workerId: orginUserArrExist[j].id,
                          name: orginUserArrExist[j].name,
                          positionId: workerExpectationList[i].positionId,
                          workerPlanId: workerExpectationList[i].workerPlanId,
                        })
                      }
                    }
                    continue;
                  }

                  let result =filterArr.filter((item, index, self) => {
                    return self.findIndex(t => JSON.stringify(t) === JSON.stringify(item)) === index;
                  });
                  let resultList =filterArr.filter(item => item.expectation !== '' || item.checkTarget !== '');
                  const ids = resultList.map(obj => obj.workerId);
                  result.forEach(item => {
                    if(!ids.includes(item.workerId)){
                      resultList.push(item)
                    }
                  })
                  item.workerExpectationList = resultList.sort(this.compareAsc("workerId"))
                }

              })
              console.log(data)
              this.positionList = data
              this.$nextTick(() => {
                this.$refs['table'].doLayout();
              })
            }


          } else {
            net.message(this, "获取数据失败", "warning");
          }
        })
      },
      saveOption(row){
        console.log(row)
        let workerExpectationList = row.workerExpectationList
        let finshList = []
        let checkTargetSum = 0
        let expectationSum = 0
        workerExpectationList.forEach(item => {
          if(item.checkTarget || item.expectation){
            finshList.push(item)
            checkTargetSum += item.checkTarget*1
            expectationSum += item.expectation*1
          }
        })
        if(checkTargetSum !== row.checkTotal*1){
          net.message(this, "总预检目标与技师预检的总和不相等，请重新检查", "warning");
          return;
        }
        if(expectationSum !== row.total*1){
          net.message(this, "总渗透率目标与技师预渗透率的总和不相等，请重新检查", "warning");
          return;
        }
        let body = {
          positionId: row.positionId,
          workerPlanId: row.workerPlanId,
          checkTotal: row.checkTotal,
          total: row.total,
          workerExpectationList: finshList
        }
        console.log(body)
        net.request("manage/workerPlan/editRelated","post", null, body).then(res => {
          if (res.code === 0) {
            row.status = 'save'
            net.message(this, "保存成功", "success");
          } else {
            net.message(this, res.msg, "warning");
          }
        })
      },

      changInput(e, row){
        row.status = 'change'
      },

      onOrderIndexChanged(e){
        this.$forceUpdate()
      },
      back(){
        let positionList = this.positionList
        let existNoSave = false
        positionList.forEach(item => {
          if(item.status === 'change'){
            existNoSave = true
            return;
          }
        })
        if(existNoSave){
          this.$confirm('检测到未保存的内容,返回后数据不会保存 是否继续?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            let href = '/planManageWorker'
            this.$router.push({ path: href });
          }).catch(() => {
            this.$message({
              type: 'info',
              message: '已取消'
            });
          });
        }else {
          let href = '/planManageWorker'
          this.$router.push({ path: href });
        }

      },
      // 排序 升序
      compareAsc: function (property) {
        return function (a, b) {
          const value1 = a[property];
          const value2 = b[property];
          return value1 - value2;
        };
      },
    },
    computed: {

    },
  };
</script>


<style lang="less" scoped>
    /deep/ .el-table th.el-table__cell {
        background: #F3F7FB !important;
        color: #364556;
    }
    input::placeholder {
        font-size: 12px;
    }
    #userList {
        padding-left: 24px;
        .title {
            width: 100%;
            height: 50px;
            line-height: 50px;
            background: #eaeefb;
            color: red;
            font-size: 20px;
            font-weight: 700;
        }
        .searchContent {
            height: 48px;
            background: #fff;
            margin: 12px 0 0px 0;
            padding-left: 12px;
            padding-top: 12px;
            .p_select {
                display: flex;
                font-size: 12px;
                float: left;
                .search_label{
                    font-family: 'PingFang SC';
                    font-style: normal;
                    margin-right: 12px;
                    font-weight: 500;
                    font-size: 14px;
                    line-height: 40px;
                    color: #787E86;
                    white-space:nowrap
                }

                .el-input , .el-select{
                    width: 160px;
                }
            }
            .back_btn{
                width: 84px;
                height: 36px;
                text-align: center;
                line-height: 36px;
                background: rgba(255, 255, 255, 0.08);
                border: 1px solid #E3E7ED;
                border-radius: 4px;
                font-size: 14px;
                color: #364556;
            }

        }
        .list_content {
            background: #fff;
            padding-left: 24px;
            padding-right: 24px;
            margin-top: 24px;
            .title_detail {
                font-size: 24px;
                line-height: 36px;
            }
        }
        .update_btn {
            width: 54px;
            height: 28px;
            background: rgba(148, 170, 204, 0.08);
            border: 1px solid #E3E7ED;
            border-radius: 14px;
            font-size: 12px;
            color: #364556;
            text-align: center;
        }
        .change_btn{
            width: 54px;
            height: 28px;
            background: #2B54FC;
            border: 1px solid #2B54FC;
            border-radius: 14px;
            font-size: 12px;
            color: #fff;
            text-align: center;
        }
    }
</style>

